<template>
  <div class="lb_live_info" v-if='infoRow.id&&userPermissions.indexOf("lb_live_info")>-1'>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-descriptions title='基本信息' :column="2">
          <template slot='title'>
            基本信息
            <el-link type='primary' icon='el-icon-edit-outline' @click='handleEdit(infoRow)' :disabled='!canEdit'
                     v-if='userPermissions.indexOf("lb_live_edit")>-1'
                     style='margin-left: 4px;font-size: 1.1em'></el-link>
          </template>
          <el-descriptions-item label='红人昵称'>{{ infoRow.nickname }}</el-descriptions-item>
          <el-descriptions-item label='直播平台'>{{ infoRow.platform_name }}</el-descriptions-item>
          <el-descriptions-item label='直播项目负责人'>{{ infoRow.leader_name }}</el-descriptions-item>
        </el-descriptions>
      </el-col>
      <el-col :span="5">
        <div class="special-info-item">
          <h4 class="special-title">直播主题</h4>
          <p class="special-content">{{ infoRow.theme || '--' }}</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="special-info-item">
          <h4 class="special-title">直播时间</h4>
          <p class="special-content">{{ $utils.parseTime(infoRow.start_at, '{y}年{m}月{d}日 {h}:{i}') }} 至
            {{ $utils.parseTime(infoRow.end_at, '{y}年{m}月{d}日 {h}:{i}') }}</p>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="special-info-item">
          <h4 class="special-title">GMV目标</h4>
          <p class="special-content">{{ infoRow.remark || '--' }}</p>
        </div>
      </el-col>
    </el-row>
    <!--    创建直播排期-->
    <CreateEdit :visible.sync='EditOpen' :id='infoRow.id' @close='handleClose' />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import CreateEdit from '@/pages/lb/live/CreateEdit.vue'

export default {
  name: 'LbLiveComponentsLbInfo',
  components: {
    CreateEdit
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    canEdit() {
      return (this.userPermissions.indexOf('lb_schedule_edit_leader') > -1 || this.infoRow.leader_id === this.userInfo.id)
    }
  },
  props: {
    infoRow: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      custom_type: 'add',
      EditOpen: false
    }
  },
  methods: {
    handleEdit(row) {
      if (row?.id) {
        this.custom_type = 'edit'
      }
      this.EditOpen = true
    },
    handleClose(){
      this.$emit('close')
    }
  },
  mounted() {
    document.title = `【${this.infoRow.nickname}】直播定品`

  }
}
</script>

<style scoped>
.special-info-item {
  border: 1px solid #e6e8eb;
  border-radius: 6px;
  padding: 16px;
  margin-top: 20px;
  height: 100%;
  min-height: 54px;
  display: flex;
  flex-direction: column;
}

.special-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.special-content {
  font-size: 14px;
  color: #606266;
  margin: 0;
  line-height: 1.5;
  flex: 1;
  word-break: break-all;
}
</style>
